import React, { useState } from "react";
import { FaSun, FaMoon, FaMars, FaVenus } from "react-icons/fa";
import { motion } from "framer-motion";
import CustomDropdown from '../common/UserCustomDropdown'; 

/* ===================== CONSTANTS ===================== */
const NAKSHATRAS = [
  "Ashwini",
  "Bharani",
  "Krittika",
  "Rohini",
  "Mrigashirsha",
  "Ardra",
  "Punarvasu",
  "Pushya",
  "Ashlesha",
  "Magha",
  "Purva Phalguni",
  "Uttara Phalguni",
  "Hasta",
  "Chitra",
  "Swati",
  "Vishakha",
  "Anuradha",
  "Jyeshtha",
  "Mula",
  "Purva Ashadha",
  "Uttara Ashadha",
  "Shravana",
  "Dhanishta",
  "Shatabhisha",
  "Purva Bhadrapada",
  "Uttara Bhadrapada",
  "Revati",
];

const RASIS = [
  "Mesha (Aries)",
  "Vrishabha (Taurus)",
  "Mithuna (Gemini)",
  "Karka (Cancer)",
  "Simha (Leo)",
  "Kanya (Virgo)",
  "Tula (Libra)",
  "Vrischika (Scorpio)",
  "Dhanu (Sagittarius)",
  "Makara (Capricorn)",
  "Kumbha (Aquarius)",
  "Meena (Pisces)",
];

// Convert to options format required by CustomDropdown
const nakshatraOptions = NAKSHATRAS.map((name, index) => ({
  value: index + 1,
  label: name,
}));

const rasiOptions = RASIS.map((name, index) => ({
  value: index + 1,
  label: name,
}));

/* ===================== DATA FOR REAL CALCULATION ===================== */
const nakshatraData = [
  { name: "Ashwini", gana: "Deva", yoni: "Horse", nadi: "Adi", varna: null }, // varna from rasi
  { name: "Bharani", gana: "Manushya", yoni: "Elephant", nadi: "Madhya" },
  { name: "Krittika", gana: "Rakshasa", yoni: "Sheep", nadi: "Antya" },
  { name: "Rohini", gana: "Manushya", yoni: "Serpent", nadi: "Antya" },
  { name: "Mrigashirsha", gana: "Deva", yoni: "Serpent", nadi: "Madhya" },
  { name: "Ardra", gana: "Manushya", yoni: "Dog", nadi: "Adi" },
  { name: "Punarvasu", gana: "Deva", yoni: "Cat", nadi: "Adi" },
  { name: "Pushya", gana: "Deva", yoni: "Sheep", nadi: "Madhya" },
  { name: "Ashlesha", gana: "Rakshasa", yoni: "Cat", nadi: "Antya" },
  { name: "Magha", gana: "Rakshasa", yoni: "Rat", nadi: "Antya" },
  { name: "Purva Phalguni", gana: "Manushya", yoni: "Rat", nadi: "Madhya" },
  { name: "Uttara Phalguni", gana: "Manushya", yoni: "Cow", nadi: "Adi" },
  { name: "Hasta", gana: "Deva", yoni: "Buffalo", nadi: "Adi" },
  { name: "Chitra", gana: "Rakshasa", yoni: "Tiger", nadi: "Madhya" },
  { name: "Swati", gana: "Deva", yoni: "Buffalo", nadi: "Antya" },
  { name: "Vishakha", gana: "Rakshasa", yoni: "Tiger", nadi: "Antya" },
  { name: "Anuradha", gana: "Deva", yoni: "Deer", nadi: "Madhya" },
  { name: "Jyeshtha", gana: "Rakshasa", yoni: "Deer", nadi: "Adi" },
  { name: "Mula", gana: "Rakshasa", yoni: "Dog", nadi: "Adi" },
  { name: "Purva Ashadha", gana: "Manushya", yoni: "Monkey", nadi: "Madhya" },
  { name: "Uttara Ashadha", gana: "Manushya", yoni: "Mongoose", nadi: "Antya" },
  { name: "Shravana", gana: "Deva", yoni: "Monkey", nadi: "Antya" },
  { name: "Dhanishta", gana: "Rakshasa", yoni: "Lion", nadi: "Madhya" },
  { name: "Shatabhisha", gana: "Rakshasa", yoni: "Horse", nadi: "Adi" },
  { name: "Purva Bhadrapada", gana: "Manushya", yoni: "Lion", nadi: "Adi" },
  { name: "Uttara Bhadrapada", gana: "Manushya", yoni: "Cow", nadi: "Madhya" },
  { name: "Revati", gana: "Deva", yoni: "Elephant", nadi: "Antya" },
];

const rasiLords = [
  "Mars",
  "Venus",
  "Mercury",
  "Moon",
  "Sun",
  "Mercury",
  "Venus",
  "Mars",
  "Jupiter",
  "Saturn",
  "Saturn",
  "Jupiter",
];

const varnaForRasi = [
  "Kshatriya",
  "Vaishya",
  "Shudra",
  "Brahmin",
  "Kshatriya",
  "Vaishya",
  "Shudra",
  "Brahmin",
  "Kshatriya",
  "Vaishya",
  "Shudra",
  "Brahmin",
];

const vashyaGroups = [
  "Quadruped",
  "Quadruped",
  "Human",
  "Water",
  "Wild",
  "Human",
  "Human",
  "Insect",
  "Quadruped",
  "Quadruped",
  "Human",
  "Water",
];

/* Vashya control matrix (boy row controls girl column: 2 full, 1 half, 0 none) */
const vashyaControl = [
  [2, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0], // boy Aries controls Leo
  [0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0], // Taurus -> Virgo, Libra
  [0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 2], // Cancer -> Pisces
  [2, 0, 0, 0, 2, 0, 0, 0, 2, 0, 0, 0], // Leo controls all except Scorpio
  [0, 1, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0],
  [0, 1, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0],
  [0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 2],
];

/* Planetary friendship for Graha Maitri */
const planetFriends = {
  Sun: {
    friend: ["Moon", "Mars", "Jupiter"],
    neutral: ["Mercury"],
    enemy: ["Venus", "Saturn"],
  },
  Moon: {
    friend: ["Sun", "Mercury"],
    neutral: ["Mars", "Jupiter", "Venus", "Saturn"],
    enemy: [],
  },
  Mars: {
    friend: ["Sun", "Moon", "Jupiter"],
    neutral: ["Venus", "Saturn"],
    enemy: ["Mercury"],
  },
  Mercury: {
    friend: ["Sun", "Venus"],
    neutral: ["Mars", "Jupiter", "Saturn"],
    enemy: ["Moon"],
  },
  Jupiter: {
    friend: ["Sun", "Moon", "Mars"],
    neutral: ["Saturn"],
    enemy: ["Mercury", "Venus"],
  },
  Venus: {
    friend: ["Mercury", "Saturn"],
    neutral: ["Mars", "Jupiter"],
    enemy: ["Sun", "Moon"],
  },
  Saturn: {
    friend: ["Mercury", "Venus"],
    neutral: ["Jupiter"],
    enemy: ["Sun", "Moon", "Mars"],
  },
};

/* Yoni compatibility table (index 0-13 animals) */
const yoniAnimals = [
  "Horse",
  "Elephant",
  "Sheep",
  "Serpent",
  "Dog",
  "Cat",
  "Rat",
  "Cow",
  "Buffalo",
  "Tiger",
  "Deer",
  "Monkey",
  "Mongoose",
  "Lion",
];
const yoniCompat = [
  [4, 2, 2, 2, 3, 1, 1, 2, 2, 2, 0, 1, 2, 2],
  [2, 4, 2, 2, 3, 1, 1, 2, 2, 2, 0, 1, 2, 2],
  [2, 2, 4, 1, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2],
  [2, 2, 1, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0],
  [3, 3, 2, 2, 4, 2, 2, 2, 2, 2, 1, 2, 2, 2],
  [1, 1, 2, 2, 2, 4, 3, 2, 2, 2, 2, 2, 2, 2],
  [1, 1, 2, 2, 2, 3, 4, 2, 2, 2, 2, 2, 2, 2],
  [2, 2, 2, 2, 2, 2, 2, 4, 3, 1, 2, 2, 2, 2],
  [2, 2, 2, 2, 2, 2, 2, 3, 4, 1, 2, 2, 2, 2],
  [2, 2, 1, 2, 2, 2, 2, 1, 1, 4, 2, 2, 2, 3],
  [0, 0, 2, 2, 1, 2, 2, 2, 2, 2, 4, 2, 2, 2],
  [1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2],
  [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2],
  [2, 2, 2, 0, 2, 2, 2, 2, 2, 3, 2, 2, 2, 4],
];

/* ===================== REAL CALCULATION FUNCTION ===================== */
const calculateGunas = (boyNak, boyRasi, girlNak, girlRasi) => {
  const boyN = boyNak - 1;
  const girlN = girlNak - 1;
  const boyR = boyRasi - 1;
  const girlR = girlRasi - 1;
  const boyGana = nakshatraData[boyN].gana;
  const girlGana = nakshatraData[girlN].gana;

  let total = 0;
  const gunas = [];

  // 1. Varna (1 point)
  const varnaOrder = { Brahmin: 4, Kshatriya: 3, Vaishya: 2, Shudra: 1 };
  const boyVarna = varnaForRasi[boyR];
  const girlVarna = varnaForRasi[girlR];
  const varnaScore = varnaOrder[boyVarna] >= varnaOrder[girlVarna] ? 1 : 0;
  total += varnaScore;
  gunas.push({
    name: "Varna",
    score: varnaScore,
    total: 1,
    desc: "Spiritual Compatibility",
  });

  // 2. Vashya (2 points) - Standard groups and scoring
  const vashyaGroups = [
    "Chatushpada", // Aries - 0
    "Chatushpada", // Taurus - 1
    "Dwipada", // Gemini - 2
    "Jalchar", // Cancer - 3
    "Vanchar", // Leo - 4
    "Dwipada", // Virgo - 5
    "Dwipada", // Libra - 6
    "Keet", // Scorpio - 7
    "Chatushpada", // Sagittarius - 8
    "Chatushpada", // Capricorn - 9
    "Dwipada", // Aquarius - 10
    "Jalchar", // Pisces - 11
  ];

  let vashyaScore = 0;
  if (vashyaGroups[boyR] === vashyaGroups[girlR]) {
    vashyaScore = 2; // Same group full points
  } else if (
    (vashyaGroups[boyR] === "Dwipada" && vashyaGroups[girlR] !== "Vanchar") || // Human controls all except Leo
    vashyaGroups[boyR] === "Vanchar" || // Leo (boy) controls everyone
    (vashyaGroups[boyR] === "Chatushpada" &&
      ["Dwipada", "Jalchar"].includes(vashyaGroups[girlR])) || // Quadruped controls Human and Water
    (vashyaGroups[boyR] === "Jalchar" && vashyaGroups[girlR] === "Jalchar") // Water controls Water
  ) {
    vashyaScore = 1; // Partial control
  }
  total += vashyaScore;
  gunas.push({
    name: "Vashya",
    score: vashyaScore,
    total: 2,
    desc: "Mutual Control",
  });

  // 3. Tara (3 points) - Count from both directions
  const countBoyToGirl = ((girlN - boyN + 27) % 27) + 1;
  const countGirlToBoy = ((boyN - girlN + 27) % 27) + 1;

  const taraBoy = countBoyToGirl % 9 || 9;
  const taraGirl = countGirlToBoy % 9 || 9;

  const badTara = [3, 5, 7];
  const scoreBoy = badTara.includes(taraBoy) ? 0 : 1.5;
  const scoreGirl = badTara.includes(taraGirl) ? 0 : 1.5;
  const taraScore = scoreBoy + scoreGirl;
  total += taraScore;
  gunas.push({ name: "Tara", score: taraScore, total: 3, desc: "Destiny" });

  // 4. Yoni (4 points)
  const boyYoniIdx = yoniAnimals.indexOf(nakshatraData[boyN].yoni);
  const girlYoniIdx = yoniAnimals.indexOf(nakshatraData[girlN].yoni);
  const yoniScore = yoniCompat[boyYoniIdx][girlYoniIdx];
  total += yoniScore;
  gunas.push({
    name: "Yoni",
    score: yoniScore,
    total: 4,
    desc: "Mentality/Sexual",
  });

  // 5. Graha Maitri (5 points)
  const boyLord = rasiLords[boyR];
  const girlLord = rasiLords[girlR];
  let maitriScore;
  if (boyLord === girlLord) maitriScore = 5;
  else {
    const relBoyToGirl = planetFriends[boyLord].friend.includes(girlLord)
      ? "friend"
      : planetFriends[boyLord].enemy.includes(girlLord)
      ? "enemy"
      : "neutral";
    const relGirlToBoy = planetFriends[girlLord].friend.includes(boyLord)
      ? "friend"
      : planetFriends[girlLord].enemy.includes(boyLord)
      ? "enemy"
      : "neutral";
    if (relBoyToGirl === "friend" && relGirlToBoy === "friend") maitriScore = 5;
    else if (relBoyToGirl === "friend" && relGirlToBoy === "neutral")
      maitriScore = 4;
    else if (relBoyToGirl === "neutral" && relGirlToBoy === "friend")
      maitriScore = 4;
    else if (relBoyToGirl === "neutral" && relGirlToBoy === "neutral")
      maitriScore = 3;
    else if (relBoyToGirl === "friend" && relGirlToBoy === "enemy")
      maitriScore = 0.5;
    else if (relBoyToGirl === "enemy" && relGirlToBoy === "friend")
      maitriScore = 0.5;
    else maitriScore = 0;
  }
  total += maitriScore;
  gunas.push({
    name: "Graha Maitri",
    score: maitriScore,
    total: 5,
    desc: "Friendship",
  });

  // 6. Gana (6 points) - Asymmetric scoring (boy-girl direction matters)
  let ganaScore = 0;
  if (boyGana === girlGana) {
    ganaScore = 6;
  } else if (boyGana === "Deva" && girlGana === "Manushya") {
    ganaScore = 6;
  } else if (boyGana === "Manushya" && girlGana === "Deva") {
    ganaScore = 5;
  } else if (boyGana === "Deva" && girlGana === "Rakshasa") {
    ganaScore = 1; // Traditional: Deva boy - Rakshasa girl = 1 (not 0)
  } else if (boyGana === "Rakshasa" && girlGana === "Deva") {
    ganaScore = 0;
  } else if (boyGana === "Manushya" && girlGana === "Rakshasa") {
    ganaScore = 5; // Some sources 5, others 1 - common is higher for Manushya boy
  } else if (boyGana === "Rakshasa" && girlGana === "Manushya") {
    ganaScore = 0;
  }
  total += ganaScore;
  gunas.push({ name: "Gana", score: ganaScore, total: 6, desc: "Temperament" });

  // 7. Bhakoot (7 points)
  const diff = (girlR - boyR + 12) % 12;
  const revDiff = (boyR - girlR + 12) % 12;
  const bad = [
    [1, 11],
    [4, 8],
    [5, 7],
  ]; // 2-12,5-9,6-8
  const isBad = bad.some((p) => diff === p[0] && revDiff === p[1]);
  const bhakootScore = isBad ? 0 : 7;
  total += bhakootScore;
  gunas.push({ name: "Bhakoot", score: bhakootScore, total: 7, desc: "Love" });

  // 8. Nadi (8 points)
  const boyNadi = nakshatraData[boyN].nadi;
  const girlNadi = nakshatraData[girlN].nadi;
  const nadiScore = boyNadi === girlNadi ? 0 : 8;
  total += nadiScore;
  gunas.push({ name: "Nadi", score: nadiScore, total: 8, desc: "Health" });

  // Verdict
  const percentage = Math.round((total / 36) * 100);
  let status, verdict, details;
  if (total >= 32) {
    status = "Excellent Match";
    verdict = "Highly Recommended";
    details = "Exceptional compatibility across all aspects.";
  } else if (total >= 28) {
    status = "Very Good Match";
    verdict = "Highly Recommended";
    details = "Strong harmony and mutual understanding.";
  } else if (total >= 21) {
    status = "Good Match";
    verdict = "Recommended";
    details = "Good overall compatibility with minor challenges.";
  } else if (total >= 18) {
    status = "Average Match";
    verdict = "Acceptable";
    details = "Moderate compatibility; efforts needed for harmony.";
  } else {
    status = "Below Average";
    verdict = "Not Recommended";
    details = "Significant challenges; careful consideration advised.";
  }

  return {
    score: total,
    total: 36,
    percentage,
    status,
    verdict,
    details,
    gunas,
  };
};

/* ===================== COMPONENT ===================== */
const HoroscopeMatch = () => {
  const [boyName, setBoyName] = useState("");
  const [boyNakshatra, setBoyNakshatra] = useState(null);
  const [boyRasi, setBoyRasi] = useState(null);

  const [girlName, setGirlName] = useState("");
  const [girlNakshatra, setGirlNakshatra] = useState(null);
  const [girlRasi, setGirlRasi] = useState(null);

  const [matchResult, setMatchResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleMatch = (e) => {
    e.preventDefault();

    if (!boyNakshatra || !boyRasi || !girlNakshatra || !girlRasi) {
      alert("Please select Nakshatra and Rasi for both partners.");
      return;
    }

    setLoading(true);

    setTimeout(() => {
      const result = calculateGunas(
        boyNakshatra,
        boyRasi,
        girlNakshatra,
        girlRasi
      );
      setMatchResult(result);
      setLoading(false);
    }, 1500);
  };

  return (
    <div className="min-h-full bg-gray-50 p-4 lg:p-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-3 mb-6">
          <FaSun className="text-orange-500" /> Horoscope Match (Gun Milan)
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* ================= FORM ================= */}
          <div className="lg:col-span-5 bg-white rounded-3xl shadow-xl p-6">
            <form onSubmit={handleMatch} className="space-y-8">
              {/* BOY */}
              <div className="border rounded-2xl p-6 bg-blue-50/30">
                <h3 className="font-bold text-blue-600 flex items-center gap-2 mb-4">
                  <FaMars /> Boy's Details
                </h3>

                <input
                  type="text"
                  placeholder="Name (Optional)"
                  value={boyName}
                  onChange={(e) => setBoyName(e.target.value)}
                  className="w-full mb-5 p-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <div className="space-y-4">
                  <CustomDropdown
                    options={nakshatraOptions}
                    value={boyNakshatra}
                    onChange={setBoyNakshatra}
                    placeholder="Select Nakshatra"
                    searchable={true}
                  />

                  <CustomDropdown
                    options={rasiOptions}
                    value={boyRasi}
                    onChange={setBoyRasi}
                    placeholder="Select Rasi (Moon Sign)"
                    searchable={true}
                  />
                </div>
              </div>

              {/* GIRL */}
              <div className="border rounded-2xl p-6 bg-pink-50/30">
                <h3 className="font-bold text-pink-600 flex items-center gap-2 mb-4">
                  <FaVenus /> Girl's Details
                </h3>

                <input
                  type="text"
                  placeholder="Name (Optional)"
                  value={girlName}
                  onChange={(e) => setGirlName(e.target.value)}
                  className="w-full mb-5 p-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-500"
                />

                <div className="space-y-4">
                  <CustomDropdown
                    options={nakshatraOptions}
                    value={girlNakshatra}
                    onChange={setGirlNakshatra}
                    placeholder="Select Nakshatra"
                    searchable={true}
                  />

                  <CustomDropdown
                    options={rasiOptions}
                    value={girlRasi}
                    onChange={setGirlRasi}
                    placeholder="Select Rasi (Moon Sign)"
                    searchable={true}
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="mx-auto block w-64 bg-rose-600 hover:bg-rose-800 disabled:opacity-70 text-white py-4 rounded-xl font-bold transition-colors"
              >
                {loading
                  ? "Calculating Compatibility..."
                  : "Calculate Compatibility"}
              </button>
            </form>
          </div>

          {/* ================= RESULT ================= */}
          <div className="lg:col-span-7">
            {matchResult ? (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="bg-white rounded-3xl shadow-xl p-8 h-full"
              >
                <div className="text-center mb-8">
                  <h3 className="text-4xl font-bold text-gray-800 mb-2">
                    {matchResult.verdict}
                  </h3>
                  <p className="text-2xl text-green-600 font-semibold">
                    {matchResult.score}/{matchResult.total} Gunas Matched (
                    {matchResult.percentage}%)
                  </p>
                  <p className="text-gray-600 mt-2">{matchResult.details}</p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  {matchResult.gunas.map((g) => (
                    <div
                      key={g.name}
                      className="p-5 border border-gray-200 rounded-2xl text-center bg-gradient-to-br from-gray-50 to-white"
                    >
                      <div className="font-semibold text-gray-700">
                        {g.name}
                      </div>
                      <div className="text-2xl font-black text-gray-900 mt-1">
                        {g.score}/{g.total}
                      </div>
                      <div className="text-xs text-gray-500 mt-1">{g.desc}</div>
                    </div>
                  ))}
                </div>
              </motion.div>
            ) : (
              <div className="h-full flex flex-col items-center justify-center bg-white rounded-3xl border-2 border-dashed border-gray-200 p-12 text-center">
                <FaMoon className="text-4xl text-gray-200 mb-6" />
                <p className="text-gray-400 text-lg">
                  Fill in the details and click calculate to see the
                  compatibility result
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HoroscopeMatch;
